import { Config } from '@comall-backend-builder/core/lib/parser';

export let config: Config = {
    entities: {},
    components: {
        synonymPage: {
            component: 'Viewport',
        },
    },
    routes: [
        {
            path: '/',
            childRoutes: [
                {
                    path: '/product',
                    breadcrumbName: '商品管理',
                    component: 'Viewport',
                    childRoutes: [
                        {
                            path: '/synonym',
                            component: 'synonymPage',
                            breadcrumbName: '同义词管理',
                            childRoutes: [
                                {
                                    path: '/',
                                    component: 'synonymListView',
                                },
                            ],
                        },
                    ],
                },
            ],
        },
    ],
};
